import { Component, Input } from '@angular/core';
import { LoanPostStatusResponse } from '../../new-loans.service';

@Component({
    selector: 'brightside-web-loan-dashboard-overview',
    templateUrl: './loan-dashboard-overview.component.html',
    styleUrls: ['./loan-dashboard-overview.component.scss'],
    standalone: false
})
export class LoanDashboardOverviewComponent {
  @Input() loan: LoanPostStatusResponse;
}
